import React from "react";
import Dropdown, {
  dropdownTypes,
} from "@visiblethread/react-components/dist/components/Dropdown";
import threeDotsIcon from "icons/three_dots_purple.svg";
import ButtonsDropdownOption from "@visiblethread/react-components/dist/components/Dropdown/ButtonsDropdownOption";
import { buttonVariants } from "@visiblethread/react-components/dist/components/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  setAllCheckedStateTo,
  setAllExpandedTo,
} from "slices/dictionarySearch/dictionarySearchSlice";
import { checkedTypes } from "constants/types";
import { folderBy } from "layout/dictionarySearch/constants";

const CategoriesActionsDropdown = () => {
  const by = useSelector((state) => state.dictionarySearch.config.folderBy);
  const folderCategories = useSelector(
    (state) => state.dictionarySearch.folder?.dictionary.categories
  );
  const documents = useSelector((state) => state.dictionarySearch.documents);
  const dispatch = useDispatch();
  const allMatchCheckState = (checkState) => {
    let result = true;
    if (by === folderBy.document) {
      documents?.forEach((d) =>
        d.dictionary?.categories.forEach((c) =>
          c.items?.forEach((item) => {
            if (
              (item.checkState === undefined &&
                checkState === checkedTypes.CHECKED) ||
              (item.checkState !== undefined && item.checkState !== checkState)
            ) {
              result = false;
            }
          })
        )
      );
      return result;
    }
    if (by === folderBy.folder) {
      folderCategories?.forEach((c) =>
        c.items?.forEach((i) => {
          if (
            (i.checkState === undefined &&
              checkState === checkedTypes.CHECKED) ||
            (i.checkState !== undefined && i.checkState !== checkState)
          ) {
            result = false;
          }
        })
      );
      return result;
    }
    return result;
  };

  const allMatchExpanded = (expanded) => {
    let result = true;
    if (by === folderBy.document) {
      documents?.forEach((d) => {
        if (
          (d.expanded === undefined && expanded === true) ||
          (d.expanded !== undefined && d.expanded !== expanded)
        ) {
          result = false;
        }
        d.dictionary?.categories.forEach((c) => {
          if (
            (c.expanded === undefined && expanded === true) ||
            (c.expanded !== undefined && c.expanded !== expanded)
          ) {
            result = false;
          }
        });
      });
      return result;
    }
    if (by === folderBy.folder) {
      folderCategories?.forEach((c) => {
        if (c.expanded !== expanded) {
          result = false;
        }
      });
      return result;
    }
    return result;
  };

  const allChecked = allMatchCheckState(checkedTypes.CHECKED);
  const allUnchecked = allMatchCheckState(checkedTypes.EMPTY);
  const allExpanded = allMatchExpanded(true);
  const allCollapsed = allMatchExpanded(false);

  return (
    <Dropdown
      type={dropdownTypes.buttons}
      propsObject={{
        button: <img src={threeDotsIcon} alt="three-dots" />,
        options: [
          <ButtonsDropdownOption
            content="Expand all"
            onClick={() => {
              dispatch(setAllExpandedTo(true));
            }}
            disabled={allExpanded}
          />,
          <ButtonsDropdownOption
            content="Collapse all"
            onClick={() => {
              dispatch(setAllExpandedTo(false));
            }}
            disabled={allCollapsed}
          />,
          <ButtonsDropdownOption
            content="Check all"
            onClick={() => {
              dispatch(setAllCheckedStateTo(checkedTypes.CHECKED));
            }}
            disabled={allChecked}
          />,
          <ButtonsDropdownOption
            content="Uncheck all"
            onClick={() => {
              dispatch(setAllCheckedStateTo(checkedTypes.EMPTY));
            }}
            disabled={allUnchecked}
          />,
        ],
        hideArrowIcon: true,
        buttonVariant: buttonVariants.borderless,
      }}
    />
  );
};

export default CategoriesActionsDropdown;
